<template lang="pug">
.v-input-password-wrapper
  .v-input-password(:class="classes")
    .v-input-password__wrapper
      input.v-input-password__field(
        :type="passwordFieldType"
        :value="value"
        :autocomplete="autocomplete"
        @input="onChange"
        @focus="onFocus"
        @blur="onBlur")
      label.v-input-password__label(:class="{ 'v-input-password__label--active': isFocused || hasValue || labelActive }") {{ label }}
      .v-input-password__bar
      button.v-input-password__btn(
        type="button"
        @click="switchVisibility")
        span.v-input-password__icon
          font-awesome-icon(
            size="sm"
            :icon="activeField ? 'eye' : 'eye-slash'")
  .v-input-password__hint-wrapper
    .v-input-password__hint(v-if="hint") {{ hint }}
</template>

<script>
export default {
  name: 'VPasswordField',

  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    invalid: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: null
    },
    labelActive: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    activeField: false,
    passwordFieldType: 'password',
    isFocused: false
  }),

  computed: {
    classes () {
      return {
        'v-input-password--invalid': this.invalid
      }
    },
    hasValue () {
      return this.value !== null && this.value !== '' && this.value !== undefined
    }
  },

  methods: {
    onChange (event) {
      this.$emit('input', event.target.value)
    },

    onFocus () {
      this.isFocused = true
    },

    onBlur () {
      this.isFocused = false
    },

    switchVisibility () {
      this.passwordFieldType = this.passwordFieldType === 'password'
        ? 'text'
        : 'password'
      this.activeField = !this.activeField
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/abstracts/_variables.scss';

.v-input-password-wrapper {
  padding-top: 2.5rem;
}

.v-input-password {
  position: relative;

  &__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
  }

  &__hint-wrapper {
    min-height: 1.5rem;
  }

  &__hint {
    color: $color-red;
    font-size: 1.2rem;
    font-weight: 300;
  }

  &__label {
    position: absolute;
    pointer-events: none;
    line-height: 1.3rem;
    font-size: 1.5rem;
    color: $color-black;
    top: 1.2rem;
    left: 1rem;
    transition: .3s ease all;

    &--active {
      top: -2.2rem;
      left: 0;
      font-size: 1.3rem;
      color: $color-gray;
    }
  }

  &__field {
    position: relative;
    display: block;
    width: 100%;
    font-size: 1.5rem;
    color: $color-black;
    outline: none;
    border: none;
    z-index: 1;
    height: 4rem;
    padding: 1rem;
    padding-right: 4rem;
    border-radius: 1rem;
    background: $color-hover;
    transition: background-color 0.2s ease;

    &::placeholder {
      color: inherit;
    }

    &:focus {
      outline: none;
    }

    &:focus ~ .v-input-password__bar:before,
    &:focus ~ .v-input-password__bar:after {
      width: 50%;
    }
  }

  &__btn {
    cursor: pointer;
    position: absolute;
    outline: none;
    border: none;
    background: transparent;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    height: 2rem;
    width: 2rem;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $color-gray;

    &:hover {
      color: $color-black;
    }
  }

  &--invalid {
    .v-input-password__label {
      color: $color-red !important;
    }

    .v-input-password__icon {
      color: $color-red !important;
    }

    .v-input-password__field {
      color: $color-red !important;
      border: .2rem solid $color-red !important;
    }

    .v-input-password__bar {
      &:before,
      &:after {
        background-color: transparent !important;
      }
    }
  }
}
</style>